import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import './catalog.css'
import { useNavigate, useParams } from "react-router-dom";
import { CatalogType } from "../../contexts/CategoryContext";


type CatalogItemProps = {
    catalog: CatalogType[];
    legendColor: string;
    showName: boolean;
    useShadow: boolean;
    isBlock?: boolean;
}

export function CatalogCarrossel({ catalog, showName,useShadow }: CatalogItemProps) {

    const navigate = useNavigate();
    const { pluginspace_id } = useParams();

    return (
        <Carousel
            showArrows={true}
            showStatus={false}
            showThumbs={false}
            infiniteLoop={true}
            autoPlay={true}
            interval={5000}
        >
            {catalog.map((item: CatalogType) =>
                <div className="item" key={item.id} onClick={() => navigate(`/${pluginspace_id}/catalog/${window.btoa(item.id.toString())}`)}>
                    {useShadow && <div className={'overlay'}></div>}
                    <img src={item.imgCatalog} className="img-carousel" />
                    {showName && <p className="legend-category_128938912" >{item.catalog}</p>}
                </div>)
            }
        </Carousel>
    );
}

export function CatalogListItem({ catalog, showName, isBlock }: CatalogItemProps) {

    const navigate = useNavigate();
    const { pluginspace_id } = useParams();

    return (
        <div className={`w-full h-full gap-4 ${!isBlock ? 'grid grid-cols-1' : 'grid grid-cols-2'}`}>
            {catalog.map((item: any) =>
                <div className="relative" key={item.id} onClick={() => navigate(`/${pluginspace_id}/catalog/${window.btoa(item.id.toString())}`)}>
                    <img src={item.imagem} className="img-carousel" />
                    {showName && <p className="legend-category" >{item.nome}</p>}
                </div>

            )
            }
        </div>


    );
}